/*
  Sequência de frames reais mostrando o produto saindo da embalagem:
  - Scroll no celular E no desktop: animação progride suavemente conforme a página é rolada.
  - No desktop com mouse: passar o mouse permite esfregar interativamente entre os frames;
    ao sair, retorna suavemente à posição baseada no scroll.
*/
(function () {
  var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function setupSequence(root) {
    if (root.dataset.frameSequenceReady) return;
    root.dataset.frameSequenceReady = 'true';

    var canvas = root.querySelector('[data-frame-canvas]');
    if (!canvas) return;

    var urls;
    try {
      urls = JSON.parse(root.getAttribute('data-frames'));
    } catch (e) {
      return;
    }
    if (!urls || !urls.length) return;

    var ctx = canvas.getContext('2d');
    var images = new Array(urls.length);

    var lastDrawnIndex = 0;
    var isHovering = false;
    function getAbsoluteTop(element) {
      var top = 0;
      while(element) {
          top += element.offsetTop || 0;
          element = element.offsetParent;
      }
      return top;
    }

    var isVisible = true;
    var isHero = root.getAttribute('data-frame-trigger') === 'scroll' || !root.closest('.product-card');
    
    // Calcula a posição real do elemento no documento, imune a bugs de window.scrollY
    var absoluteTop = getAbsoluteTop(root);

    function resizeCanvas() {
      var rect = root.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return false;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var newWidth = Math.round(rect.width * dpr);
      var newHeight = Math.round(rect.height * dpr);
      if (canvas.width !== newWidth || canvas.height !== newHeight) {
        canvas.width = newWidth;
        canvas.height = newHeight;
      }
      return true;
    }

    function drawFrame(index) {
      index = Math.max(0, Math.min(urls.length - 1, Math.round(index)));
      lastDrawnIndex = index;
      var img = images[index];
      if (!img || !img.complete || img.naturalWidth === 0) return;
      if (canvas.width === 0 || canvas.height === 0) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      var scale = Math.min(canvas.width / img.naturalWidth, canvas.height / img.naturalHeight);
      var drawWidth = img.naturalWidth * scale;
      var drawHeight = img.naturalHeight * scale;
      var offsetX = (canvas.width - drawWidth) / 2;
      var offsetY = (canvas.height - drawHeight) / 2;
      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
    }

    function calculateScrollProgress(rect, vh) {
      if (isHero) {
        if (absoluteTop < vh * 0.5) {
          // Hero no topo da página: anima conforme o usuário passa por ele
          // Inicia a animação quando o topo do elemento chega em sua posição original (absoluteTop)
          // ou se a página já carregou um pouco abaixo (começa do zero)
          var start = absoluteTop;
          var end = absoluteTop - Math.max(280, Math.min(vh * 0.65, (rect.height || 400) * 0.8));
          var progress = (start - rect.top) / (start - end);
          return Math.max(0, Math.min(1, progress));
        } else {
          // Hero no meio da página (ex: Homepage): anima conforme entra na viewport
          var start = vh * 0.85;
          var end = vh * 0.15;
          var progress = (start - rect.top) / (start - end);
          return Math.max(0, Math.min(1, progress));
        }
      } else {
        // Cards de produto em listas
        var start = vh * 0.92;
        var end = vh * 0.28;
        var progress = (start - rect.top) / (start - end);
        return Math.max(0, Math.min(1, progress));
      }
    }

    var ticking = false;
    function updateOnScroll() {
      if (isHovering) {
        ticking = false;
        return;
      }
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 800;
      
      var progress = calculateScrollProgress(rect, vh);
      drawFrame(progress * (urls.length - 1));
      ticking = false;
    }

    function requestScrollUpdate() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateOnScroll);
      }
    }

    function waitForSize(attemptsLeft) {
      if (resizeCanvas()) {
        updateOnScroll();
        return;
      }
      if (attemptsLeft > 0) {
        requestAnimationFrame(function () {
          waitForSize(attemptsLeft - 1);
        });
      }
    }

    if (window.ResizeObserver) {
      var resizeObs = new ResizeObserver(function () {
        if (resizeCanvas()) {
          if (!isHovering) {
            updateOnScroll();
          } else {
            drawFrame(lastDrawnIndex);
          }
        }
      });
      resizeObs.observe(root);
    }

    // Carregar todas as imagens da sequência
    urls.forEach(function (url, i) {
      var img = new Image();
      img.decoding = 'async';
      if (i === 0) {
        img.onload = function () {
          waitForSize(30);
          root.classList.add('is-ready');
        };
      }
      img.src = url;
      images[i] = img;
    });

    // Eventos de Scroll: funcionam SEMPRE (celular e desktop)
    window.addEventListener('scroll', requestScrollUpdate, { passive: true });
    window.addEventListener('resize', function () {
      resizeCanvas();
      requestScrollUpdate();
    });

    // Suporte a mouse scrubbing interativo no desktop
    if (hoverCapable) {
      root.addEventListener('mousemove', function (e) {
        isHovering = true;
        var rect = root.getBoundingClientRect();
        if (rect.width <= 0) return;
        var x = (e.clientX - rect.left) / rect.width;
        x = Math.max(0, Math.min(1, x));
        drawFrame(x * (urls.length - 1));
      });

      root.addEventListener('mouseleave', function () {
        isHovering = false;
        requestScrollUpdate();
      });
    }

    // Primeira renderização
    requestScrollUpdate();
  }

  function init() {
    document.querySelectorAll('[data-frame-sequence]').forEach(setupSequence);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

